<template>
<div class="xin">
  <!-- 查询框 -->
            <div class="main1" >
                <el-button type="primary" @click="back">{{$t("list.return")}}</el-button>
                <el-button @click="xiazai">{{$t("list.download")}}</el-button>
                <el-button @click="pass" v-if="this.has_pass_style==0">{{$t("list.pass")}}</el-button>
                <el-button @click="dawdata">{{$t("list.rawdata")}}</el-button>
                <el-button @click="header">{{$t("list.header")}}</el-button>
                <el-button @click="reason">{{$t("list.whyspam")}}</el-button>
                <el-button @click="abstract">{{$t("list.show")}}</el-button>
                <el-button @click="matter">{{$t("list.body")}}</el-button>
                <el-button @click="original">{{$t("list.origin")}}</el-button>
                <el-button @click="print">{{$t("list.info")}}</el-button>
                <el-button>{{$t("list.trainspam")}}</el-button>
                <el-button>{{$t("list.trainnormal")}}</el-button>
           <el-button type="text" @click="up_email" >{{
            $t("logs.up_mail1")
          }}</el-button>
          <el-button type="text" @click="next_email" >{{
            $t("logs.next_mail1")
          }}</el-button>
                <!--  <el-button icon="el-icon-search" @click="back">{{
            $t("list.return")
          }}</el-button>
                <el-button icon="el-icon-download" @click="xiazai">{{
            $t("list.download")
          }}</el-button>
                <el-button icon="el-icon-check" @click="pass">{{
            $t("list.pass")
          }}</el-button>
                <el-button icon="el-icon-receiving" @click="dawdata">{{
            $t("list.rawdata")
          }}</el-button>
                <el-button icon="el-icon-message" @click="header">{{
            $t("list.header")
          }}</el-button>
                <el-button icon="el-icon-help" @click="reason">{{
            $t("list.whyspam")
          }}</el-button>
                <el-button icon="el-icon-s-fold" @click="abstract">{{
            $t("list.show")
          }}</el-button>
                <el-button icon="el-icon-edit-outline" @click="matter">{{
            $t("list.body")
          }}</el-button>
                <el-button icon="el-icon-c-scale-to-original" @click="original">{{
            $t("list.origin")
          }}</el-button>
                <el-button icon="el-icon-document-copy" @click="print">{{
            $t("list.info")
          }}</el-button>
                <el-button icon="el-icon-notebook-2">{{
            $t("list.trainspam")
          }}</el-button>
                <el-button icon="el-icon-full-screen">{{
            $t("list.trainnormal")
          }}</el-button>-->
            </div>
    <div class="switch" v-show="this.list_first==1">

        <!-- 查询框 -->
        <div class="main">
            <el-form ref="form" label-width="80px">
                <ul>
                    <li>{{ $t("wasteInsulate1.envfrom") }}:</li>
                    <el-input placeholder v-model="col.envfrom" clearable></el-input>
                    <li>{{ $t("wasteInsulate1.envrcpt") }}:</li>
                    <el-input placeholder v-model="col.envrcpt" clearable></el-input>
                    <li>{{ $t("wasteInsulate1.subject") }}:</li>
                    <el-input placeholder v-model="col.subject" clearable></el-input>
                     <li>{{ $t("wasteInsulate1.ip") }}:</li>
                    <el-input placeholder v-model="col.ip" clearable></el-input>
                    <el-button @click="tanSend">{{ $t("table.search") }}</el-button>
                    <el-button @click="xians()" v-show="geng" type="text" class="more_s">{{ $t("table.more") }} </el-button>
                    <el-button @click="xians()" v-show="geng1" type="text" class="more_d">{{ $t("table.more1") }}</el-button>
                </ul>
            </el-form>
            <div class="search" v-show="xian">
                <ul>
                    <li>{{ $t("wasteInsulate1.hdrfrom") }}:</li>
                    <el-input placeholder v-model="col.hdrfrom" clearable></el-input>

                    <li>{{ $t("wasteInsulate1.hdrto") }}:</li>

                    <el-input placeholder v-model="col.hdrto" clearable></el-input>
                    <li>{{ $t("wasteInsulate1.attach") }}:</li>
                    <el-input placeholder v-model="col.attach" clearable></el-input>
                     <li>{{ $t("wasteInsulate1.attnum") }}:</li>
                     <el-input placeholder="" v-model="col.nbattach" >
    <el-select v-model="col.achunit" slot="prepend" placeholder="">
      <el-option label=">=" value=1></el-option>
      <el-option label="<=" value=2></el-option>
      <el-option label="=" value=3></el-option>
      
    </el-select>
   
  </el-input>
                       
                    
                </ul>
                <ul>
                   

                    <li>{{ $t("wasteInsulate1.mid") }}:</li>

                    <el-input placeholder v-model="col.mid" clearable></el-input>
                    <li>{{ $t("wasteInsulate1.url") }}:</li>
                    <el-input placeholder v-model="col.url" clearable></el-input>
                     <li>{{ $t("wasteInsulate1.bccnum") }}:</li>
<el-input placeholder="" v-model="col.nbbcc" >
    <el-select v-model="col.bccunit" slot="prepend" placeholder="">
      <el-option label=">=" value=1></el-option>
      <el-option label="<=" value=2></el-option>
      <el-option label="=" value=3></el-option>
    </el-select>
   
  </el-input>
                   
                    <li>{{ $t("wasteInsulate1.alinknum") }}:</li>
                    <el-input placeholder="" v-model="col.nblink" >
    <el-select v-model="col.linkunit" slot="prepend" placeholder="">
      <el-option label=">=" value=1></el-option>
      <el-option label="<=" value=2></el-option>
      <el-option label="=" value=3></el-option>
    </el-select>
   
  </el-input>
                    
                </ul>
                <ul>
                    

                    <li>{{ $t("wasteInsulate1.body") }}:</li>

                    <el-input placeholder v-model="col.body" clearable></el-input>
                   
                    <li>{{ $t("wasteInsulate1.istls") }}:</li>

                    <el-select v-model="col.istls" placeholder>
                        <el-option v-for="item in istls_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <li>{{ $t("wasteInsulate1.haspass") }}:</li>

                    <el-select v-model="col.haspass">
                        <el-option v-for="item in haspass1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                     <li>{{ $t("wasteInsulate1.type") }}:</li>

                    <el-select v-model="col.type">
                        <el-option v-for="item in type1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                   
                </ul>
                <ul>
                    <li>{{ $t("wasteInsulate1.minion_host") }}:</li>

                    <el-select v-model="col.minion_host">
                        <el-option v-for="item in minionhost" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
  <li> {{ $t("logs.Policy_list8") }}:</li>
                      <el-select v-model="col.isout" placeholder >
                        <el-option v-for="item in isout_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <li>{{ $t("wasteInsulate1.spam_reason") }}:</li>

                    <el-select v-model="col.spam_reason" placeholder @change="spam_reason_change">
                        <el-option v-for="item in spamreason" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-input placeholder v-model="col.subwhy" clearable v-if="this.subwhy==1"></el-input>
                    
                </ul>
                <ul>
                     <li>{{ $t("wasteInsulate1.bigs") }}:</li>
                     <div class="mailSize">
                        <el-input v-model="col.min_size"></el-input>
                        <el-select v-model="col.min_size_unit" placeholder="MB">
                            <el-option v-for="item in size_unit" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>{{ $t("wasteInsulate1.zhi") }}
                        <el-input v-model="col.max_size"></el-input>
                        <el-select v-model="col.max_size_unit" placeholder="MB">
                            <el-option v-for="item in size_unit" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <li>{{ $t("wasteInsulate1.startdate") }}:</li>
                    <el-date-picker v-model="col.startdate" type="datetimerange" :range-separator="$t('wasteInsulate1.zhi')" :start-placeholder="$t('table.sdata')" :end-placeholder="$t('table.enddata')" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"></el-date-picker>
                </ul>
            </div>
        </div>

        <!--  表格 -->

        <div class="table">
            <el-table v-loading="loading" :data="fileList1" :row-class-name="tableRowClassName" ref="multipleTable" tooltip-effect="dark" style="width: 100%"  @selection-change="handleSelectionChange" @cell-click="addSubAccount">
                <el-table-column type="selection" width="40" v-model="multipleSelection"></el-table-column>
                <el-table-column :label="$t('table.tls')" width="40">
                    <template slot-scope="scope">
                        <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt />
                    </template>
                </el-table-column>

                <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="100">
                
                </el-table-column>
                <el-table-column prop="SHOW_MINION" :label="$t('table.clusterhost')" width="96"></el-table-column>
                <el-table-column prop="MID" :label="$t('table.ID')" width="92">
                 <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.MID" placement="top">
                            <span> {{ scope.row.MID }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="IP" :label="$t('table.IP')" width="102">
                 <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.IP" placement="top">
                            <span> {{ scope.row.IP }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--  发件人 -->

                <el-table-column prop="ENVFROM" :label="$t('table.ENVFROM')" width="160">
                    <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.ENVFROM" placement="top">
                            <span> {{ scope.row.SHOW_ENVFROM }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--  收件人 -->

                <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="110">
                    <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.SHOW_MORE_RCPT" placement="top">
                            <span> {{ scope.row.ENVRCPT }}</span>
                        </el-tooltip>
                    </template>
                    <!--  

                            <template slot-scope="scope">
                                <div>
                                    <p>
                                        {{
                        scope.row.SHOW_MORE == $t('table.show')
                          ? scope.row.SHOWRCPT
                          : scope.row.SHOW_MORE_RCPT
                      }}
                                        <el-button type="text" size="small" v-if="scope.row.SHOW_MORE" v-text="scope.row.SHOW_MORE" @click="handleEdit1(scope.$index, scope.row)"></el-button>
                                    </p>
                                </div>
                            </template>
                            -->
                </el-table-column>
                <!--  邮件主题-->

                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')" :show-overflow-tooltip="true">

                   

                </el-table-column>

                <el-table-column prop="SHOW_REASON" :label="$t('table.SHOW_REASON')" width="92"></el-table-column>
                <el-table-column prop="SIZE" :label="$t('table.mailsize')" width="60"></el-table-column>

            </el-table>
        </div>

        <!--  分页 -->
        <div class="fenye" v-show="xian6">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>

            <button @click="openPostWindow" class="el-icon-download1">{{
              $t("table.download")
            }}</button>
            <button @click="bulkpass" class="el-icon-finished1">{{
              $t("table.pass")
            }}</button>

        </div>

    </div>
    
     <div class="xin1" v-loading="loading" v-show="this.list_two==1">
     
        <div class="swicth">
          
            <div class="detail_type">
            <!-- 内容区域 -->
            <div class="cent">
                <!-- 分词信息 -->

                <ol class="reason" v-show="print2">
                    <li>
                        {{ $t("list.info") }}:<el-button @click="yin4">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="print1"> </el-input>
                </ol>
                <!-- 原始正文 -->

                <ol class="reason" v-show="original2">
                    <li>
                        {{ $t("list.origin") }}:<el-button @click="yin3">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="original1">
                    </el-input>
                </ol>
                <!-- 正文分析 -->

                <ol class="reason" v-show="matter2">
                    <li>
                        {{ $t("list.body") }}:<el-button @click="yin2">{{
                $t("list.hide")
              }}</el-button>
                    </li>
                    <li v-html="matter1"></li>
                </ol>
                <!-- 显示摘要 -->

                <ol class="reason" v-show="abstract2">
                    <li>
                        {{ $t("list.show") }}:<el-button @click="yin1">{{
                $t("list.hide")
              }}</el-button>
                    </li>
                    <li v-html="abstract1"></li>
                </ol>
                <!-- 原因分析 -->
                <ol class="reason" v-show="reason2">
                    <li>
                        {{ $t("list.whyspam") }}:<el-button @click="yin">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <li style="white-space: pre-wrap;">{{ reason1 }}</li>
                </ol>

                <p v-html="fileList.SUBJECT"></p>

                <ul>
                    <li>{{ $t("list.from") }}:</li>
                    <li>{{ fileList.FROMNAME }} <span class="list_text">{{ fileList.FROMADDR }}</span> </li>
                </ul>
                <ul>
                    <li>{{ $t("list.to") }}:</li>
                    <li  class="list_text">{{fileList.TO}}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.data") }}:</li>
                    <li class="list_text">{{ fileList.DATE }}</li>
                </ul>
                <ul v-if="fileList.ATTACHMENT == 1">
                    <li>{{ $t("list.attach") }}:</li>
                    <li class="yichu">
                        ({{ fnameage }} {{ $t("list.num") }} ){{ fname }}
                    </li>
                </ul>
                <!--  信封发件人 -->
                <ul>
                    <li>{{ $t("list.envfrom") }}:</li>
                    <li>

                        {{ fileList.ENVFROM }}
                       
                    </li>
                    <li v-if="fileList.ADD_BLACK_EMAIL_IN_SPAM == 1">
                        <el-button @click="tan1">{{ $t("list.bte") }}</el-button>
                        <el-button @click="tan2">{{ $t("list.wte") }}</el-button>
                    </li>
                     <li v-if="fileList.BLACK_EMAIL_IS_IN_SPAM == 1">
                       {{$t('tan.bte')}} <el-button @click="tan11">{{$t('list.bte1')}}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">
                        {{$t('tan.wte')}} <el-button @click="tan12">{{$t('list.wte1')}}</el-button>
                    </li>
                   
                </ul>
                <ul>
                    <li>{{ $t("list.envrcpt") }}:</li>
                    <li>{{ fileList.ENVRCPT }}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.id") }}:</li>
                    <li>{{ fileList.QUEUE_ID }}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.ip") }}:</li>
                    <li>
                        {{ fileList.PEER_IP }}
                       
                    </li>
                    <li v-if="fileList.ADD_BLACK_IP_IN_SPAM == 1">
                        <el-button @click="tan3">{{ $t("list.bti") }}</el-button>
                        <el-button @click="tan4">{{ $t("list.wti") }}</el-button>
                    </li>
                   
                     <li v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">
                         {{$t('tan.bti1')}}<el-button @click="tan13">{{$t('list.bti1')}}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">
                        {{$t('tan.wti1')}} <el-button @click="tan14">{{$t('list.wti1')}}</el-button>
                    </li>
                </ul>
                <ul>
                    <li>replyto:</li>
                    <li>{{ fileList.REPLY_TO_NAME }}{{ fileList.FROMADDR }}</li>
                </ul>
            </div>

            <!-- 展示 -->
            <div class="cent2" v-html="html"></div>
            <!-- 附件 -->
            <div class="footer" v-if="fileList.ATTACHMENT == 1">
                <p>
                    <img src="/imgs/fujian.png" alt />
                    {{ $t("list.fu") }}({{ fnameage }} {{ $t("list.num") }})
                </p>
                <div v-for="v in fujian" :key="v.id">
                    <img :src="`/imgs/${v.FILETYPE}.png`" alt />

                    <ul>
                        <li>{{ v.NAME }}({{ v.HSIZE }})</li>
                        <li @click="down(v.CNT)">{{ $t("list.download") }}</li>
                    </ul>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
    data() {
        return {
             subwhy:'',
              fileList: [],
            fujian: [],
            fujian1: [],
            html: "",
            html1: "",
            loading: true,
            // 原因分析
            reason1: "",
            reason2: false,
            // 显示摘要
            abstract1: "",
            abstract2: false,
            // 正文分析
            matter1: "",
            matter2: false,

            // 原始正文
            original1: "",
            original2: false,

            // 分词信息
            print1: "",
            print2: false,
            // 附件名
            fname: "",
            // 附件个数
            fnameage: 0,
            // 判断加入还是移出黑名单
            pan1: true,
            // 自适应高度
            // clientHeight: 480,
            // clientHeight: document.documentElement.clientHeight - 200 + 'px' || '',
            list_first:1,
            list_two:0,
            details:{

            },
            // 只可以选择今天之前的日期
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            restaurants: [],
       
            // 查找
            // 查询条件
            col: {
                linkunit:'',
                bccunit:'',
                achunit:'',
                select:'',
                 istls:'',
                isl:'',
                nblink:'',
                nbbcc:'',
                nbattach:'',
                isout:'',
                envfrom: "",
                envrcpt: "",
                ip: "",
                attach: "",
                hdrfrom: "",
                hdrto: "",
                url: "",
                mid: "",
                subject: "",
                body: "",
                minion_host: "",
                startdate: "",
                type: 0,
                spam_reason: '',
                haspass: 0,
                min_size: "",
                max_size: "",
                min_size_unit: "MB",
                max_size_unit: "MB",
                 subwhy:'',
            },
            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 0,
            xian6: true,
            xian: false,
            btnText: "展示更多",
            multipleSelection: [],
            selectList: [], // 选中的数据
            excelData: [],
            allSelect: false,
            isIndeterminate: true,

            form: {
                username: "",
            },
            // 集群节点
            minionhost: [],

            // 拦截原因
            spamreason: '',
            // 类型
            type1: [],
            // 是否放行
            haspass1: [{
                    value: 0,
                    label: "未放行",
                },
                {
                    value: "1",
                    label: "已放行",
                },
            ],

            size_unit: [{
                    value: "MB",
                    label: "MB",
                },
                {
                    value: "KB",
                    label: "KB",
                },
                {
                    value: "B",
                    label: "B",
                },
            ],
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            fileList1: [],
           
            // 查看
            col1: [],
            // 搜索默认
            col2: {
                 linkunit:'',
                bccunit:'',
                achunit:'',
                 istls:'',
                isl:'',
                nblink:'',
                nbbcc:'',
                nbattach:'',
                isout:'',
                envfrom: "",
                envrcpt: "",
                ip: "",
                attach: "",
                hdrfrom: "",
                hdrto: "",
                url: "",
                mid: "",
                subject: "",
                body: "",
                minion_host: "",
                startdate: "",
                type: "",
                spam_reason: "",
                haspass: "",
                min_size: "",
                max_size: "",
                min_size_unit: "",
                max_size_unit: "",
                 subwhy:'',
            },
            geng: true,
            geng1: false,
            date_type: '',
            col_search: '',
            has_pass_style:'',
             loading_time: 0,
             page_num:'',
             isout_arr:[],
             istls_arr:[],
        };
    },

    mounted() {
         this.restaurants = this.loadAll();
        this.getFileList_1()
        // this.getHeight()
        //增加监听事件，窗口变化时得到高度。
        // window.addEventListener('resize', this.getHeight, false)
    },

    created() {
        // // console.log(147);
        // console.log(this.details);
        // // console.log(this.page)
        // this.col.page = this.page;
        // // this.col.totalnums = this.details.totalnums
        // this.col = this.details.col || this.col;

        // // console.log(this.totalnums)

        // this.getFileList_1();
    },
    methods: {
              querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { "value": "<=5", "address": "长宁区新渔路144号" },
          { "value": "6-10", "address": "上海市长宁区淞虹路661号" },
          { "value": "20", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
         
        ];
      },
      handleSelect_nbattach(item) {
        console.log(item);
      },
        spam_reason_change(val){
        console.log(val)
        if(val=='combrule' ||val=='newrule'){
            this.subwhy=1
        }else{
            this.subwhy=0

        }
    },
       // 下载
        down(a) {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "download";
            console.log(__mode);

            let rec_id = this.details.rec_id;
            console.log(rec_id);

            let index = this.details.index;
            console.log(index);

            let msgtype = this.details.msgtype;
            console.log(msgtype);
            let cnt = cnt;

            console.log(a);

            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}&mimeid=${a}`
            );
        },

        // 放行
        pass() {
            this.$confirm("将放行此邮件，你确定不是垃圾邮件吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "放行成功!",
                    });
                    this.pass1();
                   
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 放行条件
        pass1() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            let col1 = this.details.col1;
            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: "pass_elkspam",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        col: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        console.log(res);
                         this.$router.push({
                        name: "wasteInsulate1",
                    });
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 信头
        header() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "readmsg_header";
            // console.log(__mode);

            let rec_id = this.details.rec_id;
            // console.log(rec_id);

            let index = this.details.index;
            // console.log(index);

            let msgtype = this.details.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },
        // 原始邮件
        dawdata() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "readmsg_rawdt";
            // console.log(__mode);

            let rec_id = this.details.rec_id;
            // console.log(rec_id);

            let index = this.details.index;
            // console.log(index);

            let msgtype = this.details.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },
        // 分词信息
        print() {
            this.print2 = true;
        },
        // 原始正文
        original() {
            this.original2 = true;
        },
        // 正文分析
        matter() {
            this.matter2 = true;
        },
        // 显示摘要
        abstract() {
            this.abstract2 = true;
        },
        // 原因分析abstract
        reason() {
            this.reason2 = true;
        },
        yin4() {
            this.print2 = false;
            // this.abstract2 = false;
        },
        yin3() {
            this.original2 = false;
            // this.abstract2 = false;
        },
        yin2() {
            this.matter2 = false;
            // this.abstract2 = false;
        },
        yin() {
            this.reason2 = false;
            // this.abstract2 = false;
        },
        yin1() {
            // this.reason2 = false;
            this.abstract2 = false;
        },
        // 下载
        xiazai() {
            // console.log(this.details);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "download_eml";
            console.log(__mode);

            let rec_id = this.details.rec_id;
            console.log(rec_id);

            let index = this.details.index;
            console.log(index);

            let msgtype = this.details.msgtype;
            console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&is_elk=1&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },

        // },
        // 返回
        back() {
             this.list_first=1
            this.list_two=0
            // console.log(this.details);

            // let col = this.details.col1;
            // // this.$router.back();
            // this.$router.push({
            //     name: "wasteInsulate1",
            //     params: {
            //         // page: this.details.col1.page,
            //         // pagesize: this.details.col1.pagesize,

            //         // totalnums: this.details.col1.totalnums,
            //         col: col,
            //     },
            // });
            // this.$router.push({name:'wasteInsulate1',params:{
            //     col1:col1
            // }})
            // history.back(-1)
            // this.$router.go(-1);
            // console.log(this.$route);
            //
        },
        // 数据

        getFileList() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this.details);
            // 获取表单数据,搜索条件
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            let col1 = this.details.col1;
            // let  recid=this.details
            // console.log(rec_id);
            // console.log(msgtype);
            //  
            // console.log(this.details);
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "readmsg_sum",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        CONDITION_COL: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(res.data.fmstatus.code);
                    if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       this.list_first=1
            this.list_two=0
            this.loading=false
                    } else if (res.data.fmstatus.code == "2") {
                        //  alert(55555)
                        alert(res.data.fmstatus.errmsg);
                         this.list_first=1
            this.list_two=0
            this.loading=false
                    } else {
       this.restore_defaults()

                        this.fileList = res.data.ret;
                        this.fujian = res.data.ret.datalist;
                        this.has_pass_style=res.data.ret.HASPASS
                        // this.fnameage=this.fujian.length
                        if (res.data.ret.datalist) {
                            let a = 0;
                            for (let i = 0; i <= this.fujian.length; i++) {
                                a = i;
                            }
                            this.fnameage = a;
                            this.fname = res.data.ret.datalist[0].NAME;
                        }
                        // console.log(this.fujian.length)
                        // console.log(a)

                        // console.log(this.fname);
                        this.html = res.data.ret.BODY;
                        this.html1 = res.data.ret.SUBJECT;
                        this.loading = false;

                        // 分词信息
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "printparticipleinfo",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res,'111111111111')
                                this.print1 = res.data.ret.PAETICIPLE_INFO;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                        // 原始正文
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "printoriginalbody",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res);
                                this.original1 = res.data.ret.ORIG_BODY;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                        // 原因分析
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "view_reason",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                console.log(res)
                                this.reason1 = res.data.ret.REASON;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "showdigest",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res)

                                this.abstract1 = res.data.ret.DIGEST;

                                // console.log( this.html)
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "printnumemail",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res);

                                this.matter1 = res.data.ret.DETAIL;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    alert(err);
                });
        },
        // email移出黑名单
        tan11() {
            this.$confirm(`${this.$t("tan.tan11")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  email移出白名单
        tan12() {
            this.$confirm(`${this.$t("tan.tan12")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  ip移出黑名单
        tan13() {
            this.$confirm(`${this.$t("tan.tan13")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipbl",
                                blip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        }, //  ip移出白名单
        tan14() {
            this.$confirm(`${this.$t("tan.tan14")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipwl",
                                wlip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        // 弹框
        tan1() {
            // var b
            this.$confirm(`${this.$t("tan.tan1")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan2() {
            this.$confirm(`${this.$t("tan.tan2")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },

        // 弹框
        tan3() {
            // var b

            this.$confirm(`${this.$t("tan.tan3")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipbl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan4() {
            // var b

            this.$confirm(`${this.$t("tan.tan4")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipwl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        chuli(row, column, cellValue, index) {
            console.log(1)
            console.log(row, column, cellValue, index)
        },
         // 下一封

    next_email() {
          this.loading_time=2
       let page_num = Math.floor((this.totalnums + this.size - 1) / this.size);
       this.page_num=page_num
      if (this.details.INDEX_ID == this.fileList1.length - 1 &&this.page==page_num) {
        this.$message({
          type: "success",
          message: `${this.$t("logs.next_mail")}`,
        });
      } else {
         if (this.details.INDEX_ID == this.fileList1.length - 1 && this.page<page_num) {
          this.loading = true;
          this.col = this.col_search;
          this.col.page = this.col.page + 1;

          this.getFileList_2(); //加载下一页的数据
        //   setTimeout(() => {
        //     this.load_next_time(), console.log(99);
        //   }, 3000);
        }else{

       
       console.log(this.fileList1[this.details.INDEX_ID])
        let row = this.fileList1[this.details.INDEX_ID + 1];
        console.log(row, "这是第几风");
   console.log(this.page, "第xxx  页");
        this.details.rec_id = row.REC_ID;
        this.details.index = row.INDEX;
        this.details.msgtype = row.MSGTYPE;
        this.details.INDEX_ID = row.INDEX_ID;
        this.getFileList();
         }
      }
    },
    // 上一封
    up_email() {
        this.loading_time=1
      //   console.log(this.details. INDEX_ID);
      if (this.details.INDEX_ID == 0 && this.page == 1) {
        console.log(this.page, "第一页，");
        this.$message({
          type: "success",
          message: `${this.$t("logs.up_mail")}`,
        });
      } else {
        if (this.details.INDEX_ID == 0 && this.page > 1) {
          this.loading = true;
          this.col = this.col_search;
          this.col.page = this.col.page - 1;

         this.getFileList_2(); //加载上一页的数据
        //   setTimeout(() => {
        //     this.load_up_time(), console.log(99);
        //   }, 3000);
        } else {
       

          console.log(this.page, "第xxx  页");

          // console.log(this.fileList1, "有诶有数据呢");
          console.log(this.details, "details", this.details.INDEX_ID - 1);
          let row = this.fileList1[this.details.INDEX_ID - 1];
          console.log(row, "这是第几封");

          this.details.rec_id = row.REC_ID;
          this.details.index = row.INDEX;
          this.details.msgtype = row.MSGTYPE;
          this.details.INDEX_ID = row.INDEX_ID;
          this.getFileList();
        }
      }
    },
        // 下一页第一封
    load_next_time() {
      let row = this.fileList1[0];

      console.log(row, "这是第当前页最后一封吗");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      // this.getFileList();
      setTimeout(() => {
        this.getFileList(), console.log(99);
      }, 100);
    },
    // 上一页最后一封
    load_up_time() {
      let row = this.fileList1[this.fileList1.length - 1];

      console.log(row, "这是第当前页最后一封吗");
      this.details.rec_id = row.REC_ID;
      this.details.index = row.INDEX;
      this.details.msgtype = row.MSGTYPE;
      this.details.INDEX_ID = row.INDEX_ID;
      // this.getFileList();
      setTimeout(() => {
        this.getFileList(), console.log(99);
      }, 100);
    },
        // 每行点击
        addSubAccount(row) {
            // this.col1.startdate = this.date_type
            console.log(row)
            this.details.rec_id=row.REC_ID,
            this.details.index= row.INDEX,
            this.details.msgtype= row.MSGTYPE,
            this.details.INDEX_ID = row.INDEX_ID
            // this.details.col1= this.col1,
            console.log(this.details,'this.details,这是传的数据')
            this.list_first=0
            this.list_two=1
            this.loading=true
 this.abstract2 = false;
              this.reason2 = false;
               this.matter2 = false;
                this.original2 = false;
                this.print2 = false;
            this.getFileList()
        },
        // 批量放行

        bulkpass() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.loading = true;

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                console.log(sid);
                // console.log(this)
                // 获取表单数据,搜索条件
                let col = this.col;

                var arr = this.multipleSelection;
                // console.log(arr, "全选后，获取的数组");
                let multis = [];
                for (var i = 0; i < arr.length; i++) {
                    multis.push(arr[i].SEL_ID);
                }
                console.log(multis, "选中后的批量放行id");
                let multis1 = JSON.stringify(multis);
                this.$axios
                    .get("/api/adm/cgi/elkspam.cgi", {
                        params: {
                            __mode: " list_elk_rejectmail",
                            sid: sid,
                            col: col,

                            bulkpassflag: 1,
                            msg_json: multis1,
                            // screen: "real_filterlog.html",
                        },
                    })
                    .then((res) => {
                        console.log(res);
                            // this.loading = true;
          if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "1") {
                            alert(res.data.fmstatus.errmsg);
                            this.loading = false;

                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                            this.loading = false;

                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            this.fileList1 = res.data.ret.datalist;

                            this.totalnums = res.data.ret.col.totalnums;
                            this.size = res.data.ret.col.pagesize;
                            this.loading = false;
                        }
                    })
                    
            }
        },

        // 全部下载
        openPostWindow() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                var arr = this.multipleSelection;
                console.log(arr, "全选后，获取的数组");
                let multis = [];
                for (var i = 0; i < arr.length; i++) {
                    multis.push(arr[i].SEL_ID);
                }
                // console.log(multis, "选中后的id");

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                var tempForm = document.createElement("form");
                tempForm.id = "tempForm1";
                tempForm.method = "post";
                tempForm.action = "/api/adm/cgi/elkspam.cgi?";
                tempForm.target = "_blank"; //打开新页面
                var hideInput1 = document.createElement("input");
                hideInput1.type = "hidden";
                hideInput1.name = "__mode"; //后台要接受这个参数来取值
                hideInput1.value = "elk_spam_downzip"; //后台实际取到的值
                var hideInput2 = document.createElement("input");
                hideInput2.type = "hidden";
                hideInput2.name = "sid";
                hideInput2.value = `${sid}`;
                var hideInput3 = document.createElement("input");
                hideInput3.type = "hidden";
                hideInput3.name = "msg_json";
                hideInput3.value = `${multis}`;
                // 这里就是如果需要第二个参数的时候可以自己再设置;
                tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
                tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
                tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
                if (document.all) {
                    tempForm.attachEvent("onsubmit", function () {}); //IE
                } else {
                    // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
                }
                document.body.appendChild(tempForm);
                if (document.all) {
                    tempForm.fireEvent("onsubmit");
                } else {
                    tempForm.dispatchEvent(new Event("submit"));
                }
                tempForm.submit();
                document.body.removeChild(tempForm);
            }
        },

        downloadExcel() {
            this.$confirm("确定下载列表文件?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.excelData = this.selectData; //你要导出的数据list。
                    this.exportExcel();
                })
                .catch(() => {});
        },

        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array",
            });
            try {
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: "application/octet-stream",
                    }),
                    //设置导出文件名称
                    "sheetjs.xlsx"
                );
            } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
            }
            return wbout;
        },

        //  getdatatime() {
        //   //默认显示今天
        //   this.value2 = new Date();
        // },
        // 格式化时间，获取当前时间的一个月后的时间值
        Date() {
            var seperator1 = "-";

            var data = new Date();
            var Da = new Date(data.getTime());
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();
            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        // 七天前日期
        convertToLateDate() {
            var data = new Date();
            var Da = new Date(data.getTime() - 24 * 60 * 60 * 1000 * 7);
            var seperator1 = "-";
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            // var y = Da.getFullYear();
            // var m = Da.getMonth() + 1;
            // var d = Da.getDate();
            // var H = Da.getHours();
            // var mm = Da.getMinutes();
            // m = m < 10 ? "0" + m : m;
            // d = d < 10 ? "0" + d : d;
            // H = H < 10 ? "0" + H : H;
            // return y + "-" + m + "-" + d + " " + H + ":" + mm;
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();
            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        //打包下载
        // speedupCheckbox() {
        //   if (this.multipleSelection.length === 0) {
        //     this.$message({
        //       message: "请至少勾选一项，再进行操作",
        //       type: "warning",
        //     });
        //     return;
        //   } else {
        //     // this. openPostWindow()
        //     // this.speedupData();
        //     // this.exportExcel();
        //   }
        // },
        // 表格选中值
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection, "table 框选中的值");
            // console.log(this.table);
        },
        //全选
        speedupData() {
            var arr = this.multipleSelection;
            // console.log(arr, "全选后，获取的数组");
            let multis = [];
            for (var i = 0; i < arr.length; i++) {
                multis.push(arr[i].SEL_ID);
            }
            console.log(multis, "选中后的id");

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // let msg=JSON.stringify(multis)
            let __mode = "elk_spam_downzip";
            console.log(__mode);

            // window.open(
            //   `https://211.100.61.212/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&msg_json=${multis}&is_elk=1`
            // );
            this.$refs.multipleTable.clearSelection(); //操作完成清除勾选框
        },

        // 更多
        xians: function () {
            this.xian = !this.xian;

            if (this.xian) {
                this.geng = false;
                this.geng1 = true;
            } else {
                this.geng = true;
                this.geng1 = false;
            }
        },
        // 页面加载完成时，
getFileList_2() {
            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: " list_elk_rejectmail",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList1 = res.data.ret.datalist;
                        // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                       
                        this.col_search = res.data.ret.col
       this.restore_defaults()

                      if(this.loading_time==2){
                           this.load_next_time()
                      }else if(this.loading_time==1){
                           this.load_up_time()
                      }
                    }
                })
               
        },
           restore_defaults(){
           this.abstract2 = false;
              this.reason2 = false;
               this.matter2 = false;
                this.original2 = false;
                this.print2 = false;
    },
        // 数据

        getFileList_1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: " list_elk_rejectmail",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                       
          if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
            this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
            this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                           if(res.data.ret.col.spam_reason=="newrule"||res.data.ret.col.spam_reason=="combrule"){
              this.subwhy=1
            }
                        this.fileList1 = res.data.ret.datalist;
                        // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.linkunti = res.data.ret.col.linkunti;
                        this.bccunti = res.data.ret.col.bccunti;
                        this.athunti = res.data.ret.col.athunti;
                  // console.log(this.page)
                        this.minionhost = res.data.ret.q_minion_host;
                        // this.type1 = res.data.ret.q_spam_reason;
                        // 节点
                        this.minionhost = res.data.ret.q_minion_host;
                        //  类型
                        this.type1 = res.data.ret.q_type;
                        //  原因
                        this.spamreason = res.data.ret.q_spam_reason;
                        this.loading = false;
                        // for (let i = 0; i < this.fileList1.length; ++i) {
                        //     this.fileList1[i].SHOW_MORE = '展示更多'
                        // }
                        // 页面加载完成后渲染日期
                        this.col.startdate = res.data.ret.q_date;
                         this.istls_arr=res.data.ret.q_yes_no
                         this.isout_arr=res.data.ret.q_isout
                        this.date_type = res.data.ret.col.startdate
                        this.col_search = res.data.ret.col

                        console.log(this.col_search, '后台返回数据col')
                    }
                })
               
        },
        // 打开搜素
        tanSend() {
            this.loading = true;
            // this.page = 1
            const col = {
                linkunit:this.col.linkunit,
                bccunit:this.col.bccunit,
                achunit:this.col.achunit,
                  istls:this.col.istls,
                isl:this.col.isl,
                nblink:this.col.nblink,
                nbbcc:this.col.nbbcc,
                nbattach:this.col.nbattach,
                isout:this.col.isout,
                subject: this.col.subject,
                url: this.col.url,
                envfrom: this.col.envfrom,
                envrcpt: this.col.envrcpt,
                mid: this.col.mid,
                ip: this.col.ip,
                attach: this.col.attach,
                hdrfrom: this.col.hdrfrom,
                hdrto: this.col.hdrto,
                body: this.col.body,
                type: this.col.type,
                haspass: this.col.haspass,
                min_size: this.col.min_size,
                max_size: this.col.max_size,
                min_size_unit: this.col.min_size_unit,
                max_size_unit: this.col.max_size_unit,
                spam_reason: this.col.spam_reason,
                startdate: this.col.startdate,
                 subwhy:this.col.subwhy,
                minion_host: this.col.minion_host,
                page: 1,
                pagesize: this.pagesize,
            };
            let col2 = col;
            // console.log(col2, "搜索传值");
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: "list_elk_rejectmail",
                        sid: sid,
                        col: col2,
                    },
                })
                .then((res) => {
                    // this.loading = true;
                   if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    }  else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                         this.loading = false;
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                         this.loading = false;
                    }else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        console.log(res);
                         if(res.data.ret.col.spam_reason=="newrule"||res.data.ret.col.spam_reason=="combrule"){
              this.subwhy=1
            }
                        // this.col1 = this.col;
                        // let col1 = this.col1;
                        // console.log(col1);
                        // this.page = 1
                        // this.pagesize = 50
                        // this.xian=false
                        this.fileList1 = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.loading = false;
                        this.col_search = res.data.ret.col
                        console.log(this.col_search, '后台返回数据col，搜索后')
                    }
                })
               
            // 值清空
            // this.subject = "";
            // this.ip = "";

            // (this.envfrom = ""),
            //   (this.envrcpt = ""),
            //   (this.id = ""),
            //   (this.spam_reason = ""),
            //   (this.startdate = ""),
            //   (this.minion_host = ""),
            //   console.log(this.ip);
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },

        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            this.col = this.col_search
            console.log(this.col, '给后台返回数据1')
            this.col.pagesize = val;

            console.log(this.col, '给后台返回数据2')

            this.getFileList_1();
        },
        // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.col = this.col_search
            console.log(this.col, '给后台返回数据1')
            this.col.page = val;
            console.log(this.col, '给后台返回数据2')

            this.getFileList_1();
        },
        handleCurrentChange2(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '2', val);
        },
        // 打开详情页
        handleEdit(index, row) {
            // console.log(this.col1);
            // console.log(index,row)
            // this.loading = false;

            this.$router.push({
                name: "listOne1",
                params: {
                    rec_id: row.REC_ID,
                    index: row.INDEX,
                    msgtype: row.MSGTYPE,
                    is_elk: 1,
                    col1: this.col1,
                },
            });
        },
        // 收件人展示更多

        handleEdit1(index, row) {
            console.log(row);
            this.fileList1[index].SHOW_MORE = row.SHOW_MORE == `${this.$t('table.show')}` ? `${this.$t('table.yin')}` : `${this.$t('table.show')}`;
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__body tr:hover {
    cursor: pointer;

}

.biaodan {
    height: 300px;

    form {
        height: 300px;
    }
}

/deep/ .el-table--border th:first-child .cell {
    padding-left: 0px;
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//     width: 0px;
//     background: none;
// }

/deep/ .el-table__row.el-table .cell:nth-child(1) {

    padding-left: 4px;

}

/deep/ .el-table .cell:nth-child(2) {

    padding-left: 0px;

}

// 滑过每一行变色
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #c6cfdf !important;

}

/deep/ .el-input__suffix {
    .el-input__suffix-inner {
        border-color: none;

        .el-icon-circle-close:before {
            padding-right: 10px;
        }
    }
}

/deep/ .warning-row {

    background: #F2F6FB;
}

/deep/ .success-row {

    background: #fff;
}

/deep/.el-table td {
    padding: 0px 0;
    // border-right: 1px solid #ccc;
    // border-bottom: 1px solid #ccc;
    box-sizing: border-box;
}

// /deep/.el-table td:first-child {
//     border-left: 1px solid #ccc;

// }

/deep/ .el-table th.gutter {
    display: table-cell !important;
}

/deep/ .el-table colgroup.gutter {
    display: table-cell !important;
}

// td
/deep/ .cell {
    // text-align: left;

    img {
        // margin-top: 3px;
        margin: 0 auto;
        width: 14px;
        height: 14px;
        // line-height: 20px;
        display: block;
    }

    .el-button {
        margin-left: 0;
    }
}

// /deep/.el-table__row td {
//     .cell {
//         text-align: left;
//     }
// }

/deep/.el-table__row td:nth-child(4) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(5) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(6) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(7) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(8) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(9) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

/deep/.el-table__row td:nth-child(6) {
    .cell {
        text-align: left;
    }

    text-align: left;
}

.el-date-editor {
    margin-left: 10px;
    margin-top: 5px;
    // margin-bottom: 10px;
}

// /deep/ .el-input__inner {
//     padding-right: 36px;
// }

.search span {
    font-size: 14px;
    margin-left: 12px;
    color: #606266;
}

/deep/.el-tabs--border-card>.el-tabs__content {
    padding: 0;
    margin-top: 5px;
}

.block,
.jiqun {
    margin: 10px 0;
}

.block {
    display: flex;
    align-items: center;
}

.block span {
    margin: 0 38px;
}

/deep/ .el-range-editor.el-input__inner {
    display: flex;
    align-items: center;
}

.jiqun {
    display: flex;
    align-items: center;
    margin: 5px 0;
}

/deep/ .cell {
    text-align: center;
}

/deep/ .el-tabs__item {
    color: #333;
    font-size: 14px;
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border-left: 1px solid #ddd;
    // border-right: 1px solid #fff;
}

/deep/ .el-tabs__nav-scroll {
    display: flex;
    padding-left: 0px;
    justify-content: space-between;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
    font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
    border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 20px;
}

/deep/ .el-tabs__item.is-active {
    //   color: #409eff;
    background: #fff;
}

/deep/ .el-tabs__active-bar {
    height: 0;
}

/deep/ .el-date-editor {
    margin-top: 0;
}

/deep/ .el-date-editor .el-range-input {
    font-size: 12px;
    line-height: 24px;
    width: 50%;
}

/deep/.el-date-editor span {
    margin-bottom: 0px;
}

/deep/ .el-date-editor--datetimerange.el-input__inner {
    width: 330px;
}

@import "../../css/liebiao.less";
@import "../../css/breadcrumb.less";
@import "../../css/list_detail.less";

</style>
